import React from 'react';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

let TableRowItalic = React.createClass({

    overLimit: function () {
        this.props.aparicionLapizEdicion(this.props.row.Id);
    },

    viewEdit: function () {
        if (this !== null) {
            this.props.muestraEditadoNovedad(this.props.row.Id);
        }
        else {
            viewEditNoRow();
        }
    },

    viewEditClose: function () {
        this.props.ocultaEditadoNovedad();
    },

    render: function () {
        let drawName = null;
        let drawNovedad = null;
        let timeToNovedad = null;
        let fecha = null;
        let hora = null;
        let name = this.props.row.Descripcion;
        let valorNovedad;
        if (this.props.novedad !== undefined) {
            valorNovedad = this.props.novedad.ValorNovedad;
            let valorAnterior = this.props.novedad.ValorAnterior;

            timeToNovedad = this.props.novedad.FechaHoraModificacion.replace("T", " ").replace("Z", "");
            fecha = timeToNovedad.substring(0, 10).split("-");
            hora = timeToNovedad.substring(16, 11);

            name = name + " (" + this.props.row.TipoDeEmpresa + "):"

            drawName = <div className="col-md-5">
                <label className="label-secondary">{name}</label>
            </div>

            if (this.props.editadoRow == true) {
                valorAnterior = GlobalHelper.ConvertirNumeroMilesMillones(valorAnterior);

                drawNovedad = <div className="row">
                    <div className="col-md-6">
                    </div>
                    <div className="col-md-6">
                        <p><sub><i>Editado el {fecha[2] + "-" + fecha[1]} a las {hora} por {this.props.novedad.UsuarioLoginModificacion}. Era ${valorAnterior}.</i></sub><a className="clickable" onClick={this.viewEditClose}><sub><ins><i>Cerrar</i></ins></sub></a></p>
                    </div>
                </div>
            }
            else {
                drawNovedad = <div className="row">
                    <div className="col-md-6">
                    </div>
                    <div className="col-md-6">
                        <a className="clickable" onClick={this.viewEdit}><sub><ins><i>Editado</i></ins></sub></a>
                    </div>
                </div>
            }

        } else {
            name = name + " (Nueva):"

            drawName = <div className="col-md-5">
                <label className="label-secondary"><i>{name}</i></label>
            </div>
        }

        valorNovedad = GlobalHelper.ConvertirNumeroMilesMillones(valorNovedad);

        return (
            <div className="row">
                <div className="col-md-1">
                </div>
                {drawName}
                <div className="col-md-6" onMouseOver={this.overLimit}>
                    <label className="label-secondary"><i>$</i></label>
                    <label className="label-secondary color-azul-claro"><i>{valorNovedad}</i></label>
                </div>
                {drawNovedad}
            </div>
        );
    }
});

export default TableRowItalic

